'use strict';

import UserView from '../common/views/user.js';
import '../../styles/_user.scss';
import '../../styles/_votegrid.scss';

module.exports = UserView;



// WEBPACK FOOTER //
// ./app/scripts/views/user.js